import {
  SUPER_ADMIN_SET_USERS,
  SUPER_ADMIN_ADD_USERS,
  SUPER_ADMIN_CLEAR_USERS,
  SUPER_ADMIN_UPDATE_USER_FIELD_SUCCESS,
  SUPER_ADMIN_SET_USER_PHANTOM_SUCCESS,
  SUPER_ADMIN_SET_USER_EMAIL_VERIFIED_SUCCESS,
} from '../types';

interface SuperClientUser {
  id: string | number;
  [key: string]: unknown;
}

type UsersState = SuperClientUser[];

interface UsersAction {
  type: string;
  users?: SuperClientUser[];
  user?: SuperClientUser;
}

const initialState: UsersState = [];

const uniquefy = (existingUsers: UsersState, newUsers: UsersState): UsersState => {
  const existingUserIds = existingUsers.map((user) => user.id);
  const uniqueNewUsers = newUsers.filter((user) => !existingUserIds.includes(user.id));
  return [...existingUsers, ...uniqueNewUsers];
};

const replaceUser = (state: UsersState, updatedUser: SuperClientUser): UsersState =>
  state.map((user) => (user.id === updatedUser.id ? { ...user, ...updatedUser } : user));

const Users = (state: UsersState = initialState, action: UsersAction): UsersState => {
  switch (action.type) {
    case SUPER_ADMIN_SET_USERS:
      return [...(action.users ?? [])];
    case SUPER_ADMIN_ADD_USERS:
      return uniquefy(state, action.users ?? []);
    case SUPER_ADMIN_CLEAR_USERS:
      return initialState;
    case SUPER_ADMIN_UPDATE_USER_FIELD_SUCCESS:
    case SUPER_ADMIN_SET_USER_PHANTOM_SUCCESS:
    case SUPER_ADMIN_SET_USER_EMAIL_VERIFIED_SUCCESS:
      return action.user ? replaceUser(state, action.user) : state;
    default:
      return state;
  }
};

export default Users;
